import { nbNO } from '@clerk/localizations';

export const nbNOFagmobler = (pathname: string) => {
  const isRegister = pathname.startsWith('/kunde/register');

  return {
    ...nbNO,
    signIn: {
      ...nbNO.signIn,
      phoneCode: {
        ...nbNO.signIn?.phoneCode,
        title: 'Kode sendt til din mobil',
        subtitle: 'Engangskode har blitt sendt til',
      },
      start: {
        ...nbNO.signIn?.start,
        title: 'Logg inn',
        subtitle: 'Logg inn med Vipps eller telefonnummer.',
        actionText: 'Har du ikke en bruker?',
        actionLink: 'Registrer deg her',
      },
    },
    signUp: {
      ...nbNO.signUp,
      phoneCode: {
        ...nbNO.signUp?.phoneCode,
        title: 'Kode sendt til din mobil',
        subtitle: 'Engangskode har blitt sendt til',
      },
      start: {
        ...nbNO.signUp?.start,
        title: 'Opprett ny bruker',
        subtitle: 'Opprett en bruker med Vipps eller telefonnummer.',
      },
    },
    socialButtonsBlockButton: 'Logg inn med',
    formButtonPrimary: isRegister ? 'Opprett ny bruker' : 'Logg inn',
  };
};

//TODO: find a way to localize these strings
//You need to send a verification code before attempting to verify.
//Success
//Incorrect code
